export type AnalyticsSurface = "legacy" | "v2";

export type AnalyticsSurfaceState = {
  hasAnalyticsV2: boolean | undefined;
};

export const ANALYTICS_LEGACY_LINK = "/dashboard/analytics";
export const ANALYTICS_V2_LINK = "/dashboard/analytics/v2";

/**
 * Picks which analytics surface a client sees. Legacy is the default and stays
 * the surface for every tenant the `analyticsV2` flag has not been switched on
 * for — including while the feature list is still loading, so a flagged-off
 * tenant never flashes the new shell.
 */
export function resolveAnalyticsSurface(
  state: AnalyticsSurfaceState,
): AnalyticsSurface {
  return state.hasAnalyticsV2 === true ? "v2" : "legacy";
}

/**
 * Where the sidebar's analytics entry points. The two surfaces live at
 * separate paths and both stay routable whatever the flag says, so a flagged
 * tenant keeps the legacy pages they were already using.
 */
export function analyticsSurfaceLink(surface: AnalyticsSurface): string {
  return surface === "v2" ? ANALYTICS_V2_LINK : ANALYTICS_LEGACY_LINK;
}
